import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import { usePost } from './../../apis/ApiRequests';
import { useAuth } from '../../contexts/AuthContext';
import { dateToString } from '../../utils/Library';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import UpdateIcon from '@mui/icons-material/Update';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { useGridApiRef } from '@mui/x-data-grid';

const BidDataList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const luserName      = authInfo.userName;
    const authority      = authInfo.authority;
    const today          = authInfo.targetDate;
    
    const search    = useLocation().search;
    const query     = new URLSearchParams(search);
    const targetDate  = query.get("targetDate") || today;
    const checkStatus  = query.get("checkStatus") || 1;
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const apiRef          = useGridApiRef();

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [entryDate, setEntryDate] = useState(targetDate);
    const [condition , setCondition] = useState('');
    const [searchStatus , setSearchStatus] = useState(checkStatus);
    const [searchCount, setSearchCount] = useState(0);
    const [dataGridHeight, setDataGridHeight] = useState(window.innerHeight - 210);
    const [dataInputList, setDataInputList] = useState([]);
    const [checkedDataInputList, setCheckedDataInputList] = useState([]);
    const [targetId, setTargetId] = useState(0);
    const [targetCell, setTargetCell] = useState('methodCode');
    const [prevRow, setPrevRow] = useState({});
    const [requireMessage, setRequireMessage] = useState('')
    const [openDialogFishMethod, setOpenDialogFishMethod] = useState(false);
    const [openDialogShip, setOpenDialogShip] = useState(false);
    const [openDialogFishSpec, setOpenDialogFishSpec] = useState(false);
    const [openDialogTrader, setOpenDialogTrader] = useState(false);
    const [openDialogTank, setOpenDialogTank] = useState(false);
    const [fishSpecList, setFishSpecList] = useState([]);
    const [shipList, setShipList] = useState([]);
    const [fishMethodList, setFishMethodList] = useState([]);
    const [traderList, setTraderList] = useState([]);
    const [tankList, setTankList] = useState([]);
    
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue        : false,
        snackBarTrue_print  : false,
        snackBarFalse       : false,
        require             : false,
        confirm             : false,
        confirm_next        : false,
        confirm_delete_row  : false,
        confirm_register    : false,
        confirm_status_done : false,
        confirm_status_none : false
    });
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchData / BidGroup
	//-----------------------------------------------
	const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
	const searchData = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.Transaction',
            'methodName'      : 'searchData',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'type'            : '2',
            'keyword1'        : numericDate,
            'keyword2'        : condition,
            'keyword3'        : searchStatus
        }
        await searchData_post(postData);
	};
	//-----------------------------------------------
    // API - updateTransaction / Transaction
	//-----------------------------------------------
    const { response : setData_res, loading : setData_Loading, post:setData_post } = usePost();
    const setData = async (targetDate) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.Transaction',
            'methodName'      : 'setDataByUser',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'type'            : '2',
            'activeFlag'      : targetDate.activeFlag,
            'reportNo'        : targetDate.reportNo,
            'reportSeq'       : targetDate.reportSeq,
            'entryDate'       : numericDate, 
            'uniqueId'        : targetDate.uniqueId,
            'bidGroupNo'      : targetDate.bidGroupNo,
            'senmeiCode'      : targetDate.senmeiCode,
            'senmei'          : targetDate.senmei,
            'gyoshuCode'      : targetDate.gyoshuCode,
            'gyoshu'          : targetDate.gyoshu,
            'nisugata'        : targetDate.nisugata,
            'kikakuCode'      : targetDate.kikakuCode,
            'kikaku'          : targetDate.kikaku,
            'methodCode'  : targetDate.methodCode,
            'method'      : targetDate.method,
            'danbeNo'  : targetDate.danbeNo,
            'danbe'      : targetDate.danbe,
            'bidMode'      : targetDate.bidMode,
            'kgSuryo'         : targetDate.kgSuryo,
            'kgKubun'         : targetDate.kgKubun,
            'suryo'           : targetDate.suryo,
            'traderCode'      : targetDate.traderCode,
            'trader'          : targetDate.trader,
            'entrySuryo'      : targetDate.entrySuryo,
            'entryUnit'       : targetDate.entryUnit,
            'bidSuryo'        : targetDate.bidSuryo,
            'tanka'           : targetDate.tanka,
            'checkStatus'     : 0,
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost();
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_ship_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost();
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta.OriginalFishSpec
    //-----------------------------------------------
    const { response : getDataAll_fishSpec_res, post : getDataAll_fishSpec_post } = usePost();
    const getDataAll_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'searchDataByOriginalCode',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getDataByOriginalCode',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.FishMethod
	//-----------------------------------------------
    const { response : getDataAll_fishMethod_res, post : getDataAll_fishMethod_post } = usePost();
    const getDataAll_fishMethod = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishMethod_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishMethod
	//-----------------------------------------------
    const { response : getData_fishMethod_res, post : getData_fishMethod_post } = usePost()
    const getData_fishMethod = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishMethod_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta.Trader
    //-----------------------------------------------
    const { response : getDataAll_trader_res, post : getDataAll_trader_post } = usePost();
    const getDataAll_trader = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Trader',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_trader_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Trader
	//-----------------------------------------------
    const { response : getData_trader_res, post : getData_trader_post } = usePost()
    const getData_trader = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Trader',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_trader_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta.Tank
    //-----------------------------------------------
    const { response : getDataAll_tank_res, post : getDataAll_tank_post } = usePost();
    const getDataAll_tank = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Tank',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_tank_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Tank
	//-----------------------------------------------
    const { response : getData_tank_res, post : getData_tank_post } = usePost()
    const getData_tank = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Tank',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_tank_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        getDataAll_fishMethod();
        getDataAll_ship();
        getDataAll_fishSpec();
        getDataAll_trader();
        getDataAll_tank();
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 210);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByDataInput / bidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setDataInputList([]);
        if (searchData_res) {
            setDataInputList(searchData_res.Data);
        }
    }, [searchData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            setMessageInfo('confirm_delete_row', false);
            setMessageInfo('confirm_register', false);
            setMessageInfo('snackBarTrue', true);
            setSearchCount(searchCount+1);
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishMethod)
	//-----------------------------------------------
    useEffect(() => {
        setFishMethodList([]);
        if (getDataAll_fishMethod_res) {
            setFishMethodList(getDataAll_fishMethod_res.Data);
        }
    }, [getDataAll_fishMethod_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([]);
        if (getDataAll_ship_res) {
            setShipList(getDataAll_ship_res.Data);
        }
    }, [getDataAll_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_originalFishSpec)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecList([]);
        if (getDataAll_fishSpec_res) {
            setFishSpecList(getDataAll_fishSpec_res.Data);
        }
    }, [getDataAll_fishSpec_res]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_trader)
    //-----------------------------------------------
    useEffect(() => {
        setTraderList([]);
        if (getDataAll_trader_res) {
            setTraderList(getDataAll_trader_res.Data);
        }
    }, [getDataAll_trader_res]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_tank)
    //-----------------------------------------------
    useEffect(() => {
        setTankList([]);
        if (getDataAll_tank_res) {
            setTankList(getDataAll_tank_res.Data);
        }
    }, [getDataAll_tank_res]);
	//-----------------------------------------------
    // useEffect - チェック済みのデータを操作する
	//-----------------------------------------------
    useEffect(() => {
        if (dataInputList) {
            // bidStatusが1の行のIDを集める
            const selectedRows = dataInputList.filter(row => row.deliveryStatus === 1).map(row => row.id);
            setCheckedDataInputList(selectedRows);
        }
    }, [dataInputList]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_ship_res.displayName) {
                            row.senmeiCode  = getData_ship_res.code;
                            row.senmei      = getData_ship_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.senmeiCode  = prevRow.senmeiCode;
                            row.senmei      = prevRow.senmei;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_fishSpec_res.originalName) {
                            row.gyoshuCode  = getData_fishSpec_res.originalCode;
                            row.gyoshu      = getData_fishSpec_res.originalName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.gyoshuCode  = prevRow.gyoshuCode;
                            row.gyoshu      = prevRow.gyoshu;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_standard_res.displayName) {
                            row.kikakuCode  = getData_standard_res.code;
                            row.kikaku      = getData_standard_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.kikakuCode  = prevRow.kikakuCode;
                            row.kikaku      = prevRow.kikaku;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_standard_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishMethod)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishMethod_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_fishMethod_res.displayName) {
                            row.methodCode  = getData_fishMethod_res.code;
                            row.method      = getData_fishMethod_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.methodCode  = prevRow.methodCode;
                            row.method      = prevRow.method;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_fishMethod_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_trader)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_trader_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_trader_res.displayName) {
                            row.traderCode  = getData_trader_res.code;
                            row.trader      = getData_trader_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.traderCode  = prevRow.traderCode;
                            row.trader      = prevRow.trader;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_trader_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_tank)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_tank_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_tank_res.displayName) {
                            row.danbeNo  = getData_tank_res.code;
                            row.danbe      = getData_tank_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.danbeNo  = prevRow.danbeNo;
                            row.danbe      = prevRow.danbe;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_tank_res]);

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setEntryDate(value);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today);
        setCondition('');
        setSearchStatus(1);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const handleClick_addRow = (mode) => {
        let newId = dataInputList.length > 0 ? Math.max(...dataInputList.map(r => r.id)) + 1 : 1;
        if (mode && !targetId) {
            setRequireMessage('明細を追加する行を選択してください');
            setMessageInfo('require', true);
        } else {
            const newRows = generateNewRows(newId, 1, mode);
            setDataInputList(prevDataInputList => 
                [...prevDataInputList, ...newRows].sort((a, b) => {
                  // reportNoが空の場合は最大値として扱う
                  if (a.reportNo === '' && b.reportNo !== '') return 1;
                  if (a.reportNo !== '' && b.reportNo === '') return -1;
              
                  // reportNoがどちらも空の場合はreportSeqで比較
                  if (a.reportNo === '' && b.reportNo === '') {
                    return a.reportSeq - b.reportSeq;
                  }
              
                  // 通常のreportNoの比較
                  if (a.reportNo < b.reportNo) return -1;
                  if (a.reportNo > b.reportNo) return 1;
              
                  // reportNoが同じ場合、reportSeqで比較
                  return a.reportSeq - b.reportSeq;
                })
            );  
        }
    }
	//-----------------------------------------------
    // eventHandler - 漁法ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishMethod_close = () => {
        setOpenDialogFishMethod(false);
    };
	//-----------------------------------------------
    // eventHandler - 荷主ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_ship_close = () => {
        setOpenDialogShip(false);
    };
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec_close = () => {
        setOpenDialogFishSpec(false);
    };
	//-----------------------------------------------
    // eventHandler - 仲買人ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_trader_close = () => {
        setOpenDialogTrader(false);
    };
	//-----------------------------------------------
    // eventHandler - 水槽ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_tank_close = () => {
        setOpenDialogTank(false);
    };
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const generateNewRows = (startId, count, mode) => {
        const rows = [];
        let reportNo;
        let reportSeq = 1;
        if (mode) {
            const item = dataInputList.find((data) => data.id === targetId);
            reportNo = item.reportNo;
            const relatedReports = dataInputList.filter((data) => data.reportNo === reportNo);
            const maxReportSeq = Math.max(...relatedReports.map((data) => data.reportSeq));
            reportSeq = maxReportSeq + 1; // 最大値に1を加える
        }
        for (let i = 0; i < count; i++) {
            rows.push({
                id: startId + i,
                reportNo       : reportNo,
                reportSeq      : reportSeq,
                entryDate      : entryDate, 
                uniqueId      : prevRow.uniqueId,
                bidGroupNo        : prevRow.bidGroupNo,
                senmeiCode     : prevRow.senmeiCode,
                senmei         : prevRow.senmei,
                gyoshuCode     : prevRow.gyoshuCode,
                gyoshu         : prevRow.gyoshu,
                nisugata       : prevRow.nisugata,
                nisugataCode   : prevRow.nisugataCode,
                kikakuCode     : prevRow.kikakuCode,
                kikaku         : prevRow.kikaku,
                methodCode : prevRow.methodCode,
                method     : prevRow.method,
                kgSuryo        : prevRow.kgSuryo,
                kgKubun        : prevRow.kgKubun,
                kgKubunCode    : prevRow.kgKubunCode,
                danbeNo : prevRow.danbeNo,
                danbe     : prevRow.danbe,
                bidModeCode     : prevRow.bidModeCode,
                bidMode     : prevRow.bidMode,
                suryo          : '',
                traderCode     : '', 
                trader         : '', 
                entrySuryo     : '', 
                entryUnit      : '', 
                bidSuryo       : '', 
                tanka          : '', 
                checkStatus    : 0,
            })
        }
        return rows;
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - グリッドの見出し
	//-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'reportNo', headerName: '伝票No', width: 122, columnSeparatorWidth: 1, sortable:false, },
        { field: 'reportSeq', headerName: '明細No', width: 70, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', },
        { field: 'bidMode', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        {
            field: 'bidModeCode',
            headerName: '販売形態',
            headerAlign:'left',
            width: 80, sortable:false,
            renderCell: (params) => (
              <div>
                {bidModeMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'methodCode', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'method', headerName: '漁法', width: 150, columnSeparatorWidth: 1, sortable:false, headerAlign:'left', },
        { field: 'gyoshuCode', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'gyoshu', headerName: '魚種', width: 150, columnSeparatorWidth: 1, sortable:false, headerAlign:'left', },
        { field: 'traderCode', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'trader', headerName: '仲買人', width: 150, columnSeparatorWidth: 1, sortable:false, },
        { field: 'tanka', headerName: '単価', width: 80, columnSeparatorWidth: 1, type:'number', sortable:false, editable:true},
        { field: 'bidSuryo', headerName: '数量', width: 80, columnSeparatorWidth: 1, type:'number', sortable:false, editable:true},
        { field: 'kgKubun', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        {
            field: 'kgKubunCode',
            headerName: '単位',
            width: 80, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'danbeNo', headerName: '', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'danbe', headerName: '水槽', width: 120, columnSeparatorWidth: 1, sortable:false, },
    ];
    const unitMapping = {
        1: 'Kg',
        0: '箱',
        2: '本',
    };
    const bidModeMapping = {
        0: 'プール',
        1: '個別',
    };
    //-----------------------------------------------
    // dataGrid - テンキーのクリック
    //-----------------------------------------------
    const handleCellKeyDown = (event, params) => {
        setTargetId(event.id);
        setTargetCell(event.field);
    };
    //-----------------------------------------------
    // dataGrid - 行の更新処理
    //-----------------------------------------------
    const handleProcessRowUpdate = (newRow, oldRow) => {
        let targetId = newRow.id;
        setTargetId(targetId);
        setDataInputList((prevData) => {
            return prevData.map((row) => {
                if (row.id === targetId) {
                    if (targetCell == 'senmeiCode') getData_ship(newRow.senmeiCode);
                    if (targetCell == 'gyoshuCode') getData_fishSpec(newRow.gyoshuCode);
                    if (targetCell == 'kikakuCode') getData_standard(newRow.kikakuCode);
                    if (targetCell == 'methodCode') getData_fishMethod(newRow.methodCode);
                    if (targetCell == 'traderCode') getData_trader(newRow.traderCode);
                    if (targetCell == 'danbeNo') getData_tank(newRow.danbeNo);
                    if (targetCell == 'nisugata') {
                        if (newRow.nisugata == 1) {
                            newRow.nisugataCode = 1;
                        } else if (newRow.nisugata == 0) {
                            newRow.nisugataCode = 0;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            newRow.nisugataCode = prevRow.nisugataCode;
                            newRow.nisugata     = prevRow.nisugata;
                        }
                    }
                    if (targetCell == 'kgKubun') {
                        if (newRow.kgKubun == 1) {
                            newRow.kgKubunCode = 1;
                        } else if (newRow.kgKubun == 0) {
                            newRow.kgKubunCode = 0;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            newRow.kgKubunCode = prevRow.kgKubunCode;
                            newRow.kgKubun     = prevRow.kgKubun;
                        }
                    }
                    if (targetCell == 'bidMode') {
                        if (newRow.bidMode == 1) {
                            newRow.bidModeCode = 1;
                        } else if (newRow.bidMode == 0) {
                            newRow.bidModeCode = 0;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            newRow.bidModeCode = prevRow.bidModeCode;
                            newRow.bidMode     = prevRow.bidMode;
                        }
                    }
                    return newRow;
                }
                return row;
            });
        });
        return newRow;
    };
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataInputList = (event) => {
        if (event.field === '__check__') {
            if (checkedDataInputList.includes(event.id)) {
                setCheckedDataInputList(checkedDataInputList.filter((checkedDataInputList, index) => (checkedDataInputList !== event.id)));
            } else {
                setCheckedDataInputList((checkedDataInputList)=>[...checkedDataInputList, event.id]);
            }
        }
        // 対象のセルはマスタヘルプを表示
        if (event.field == 'method') setOpenDialogFishMethod(true);
        if (event.field == 'senmei') setOpenDialogShip(true);
        if (event.field == 'gyoshu') setOpenDialogFishSpec(true);
        if (event.field == 'trader') setOpenDialogTrader(true);
        if (event.field == 'danbe') setOpenDialogTank(true);

        // 現在のフォーカスをセット
        setTargetId(event.id);
        setTargetCell(event.field);

        dataInputList.map((row) => {
            if (row.id === event.id) {
                setPrevRow(row);
            }
        });
    };
	//-----------------------------------------------
    // dataGrid - フォーカス制御
	//-----------------------------------------------
    useEffect(() => {
        // データが読み込まれていることを確認
        if (dataInputList.length > 0) {
            
            // フォーカスを右側のセルに移動する
            let i = targetId;
            let j = 'bidMode';
            if (targetId) {
                if (targetCell == 'bidMode') j = 'methodCode';
                if (targetCell == 'methodCode') j = 'gyoshuCode';
                //if (targetCell == 'senmeiCode') j = 'gyoshuCode';
                if (targetCell == 'gyoshuCode') j = 'traderCode';
                if (targetCell == 'traderCode') j = 'tanka';
                if (targetCell == 'tanka') j = 'bidSuryo';
                if (targetCell == 'bidSuryo') j = 'kgKubun';
                if (targetCell == 'kgKubun') j = 'danbeNo';
                if (targetCell == 'danbeNo') {
                    ++i;
                    j = 'bidMode';
                    setTargetId(j);
                }
                apiRef.current.setCellFocus(i, j);
            }
        }
    }, [dataInputList]);
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
    // Function - 登録処理
	//-----------------------------------------------
    const register = (status) => {

        dataInputList.map((targetData) => {
            targetData.activeFlag  = 1;
            setData(targetData);
        });
        return false;
    };
	//-----------------------------------------------
    // Function - 選択行の削除
	//-----------------------------------------------
    const delete_row = async () => {
        checkedDataInputList.map((item) => {
            dataInputList.map((targetData) => {
                if (item == targetData.id) {
                    targetData.activeFlag  = 0;
                    setData(targetData);
                }
            })
        });
        const newList = dataInputList.filter((targetData) => {
            return !checkedDataInputList.includes(targetData.id);
        });
        setDataInputList(newList);
        setCheckedDataInputList([]);
        return false;
    };
    //-----------------------------------------------
    // Function - 漁法マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishMethod = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.methodCode = code
                      row.method     = displayName
                      return row
                  }
              return row;
            })
        });
        handleClick_dialog_fishMethod_close();
    };
    //-----------------------------------------------
    // Function - 荷主マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_ship = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.senmeiCode = code
                      row.senmei     = displayName
                      return row
                  }
              return row;
            })
        });
        handleClick_dialog_ship_close();
    };
    //-----------------------------------------------
    // Function - 魚種マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpec = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.gyoshuCode = code
                      row.gyoshu     = displayName
                      return row
                  }
              return row;
            })
        });
        handleClick_dialog_fishSpec_close();
    };
    //-----------------------------------------------
    // Function - 仲買人マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_trader = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.traderCode = code
                      row.trader     = displayName
                      return row
                  }
              return row;
            })
        });
        handleClick_dialog_trader_close();
    };
    //-----------------------------------------------
    // Function - 水槽マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_tank = (code, displayName) => {
        setDataInputList((prevData) => {
              return prevData.map((row) => {
                  if (row.id === targetId) {
                      row.danbeNo = code
                      row.danbe     = displayName
                      return row
                  }
              return row;
            })
        });
        handleClick_dialog_tank_close();
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='dataInput bodyContens'>
                <TitleBar title="入札データ補正" />
                <div className='mainContents'>
                    <Frame classname="frame" title="補正データ検索">
                        <div style={{display:'flex'}}>
                            <div> 
                                <BidSearchForm
                                    targetDateId       = "dataInput_targetDate"
                                    targetDateValue    = { entryDate }
                                    targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                    keywordId          = "dataInput_condition"
                                    keywordValue       = { condition }
                                    keywordOnChange    = { (e) => setCondition(e.target.value) }
                                    handleSearch       = { () => handleClick_search() }
                                    handleSearchClear  = { () => handleClick_search_clear() }
                                />
                            </div>
                            <div style={{marginLeft:'40px'}}>
                                <Button
                                    color     = "primary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<UpdateIcon />}
                                    onClick   = { () => setMessageInfo('confirm_register', true) }
                                >
                                保存
                                </Button>
                            </div>
                            {/*
                            <div style={{marginLeft:'40px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<AddCircleIcon />}
                                    onClick   = {() => handleClick_addRow(0) }
                                >
                                行追加
                                </Button>
                            </div>
                            */}
                            <div style={{marginLeft:'60px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<AddCircleIcon />}
                                    onClick   = {() => handleClick_addRow(1) }
                                >
                                行追加
                                </Button>
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff', backgroundColor: 'grey'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<DeleteIcon />}
                                    onClick   = {() => setMessageInfo('confirm_delete_row', true) }
                                >
                                行削除
                                </Button>
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                apiRef = { apiRef }
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { dataInputList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                disableRowSelectionOnClick = {false}
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClick_dataInputList(event)}
                                processRowUpdate           = {handleProcessRowUpdate}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedDataInputList(newSelectionModel) }}
                                rowSelectionModel          = {checkedDataInputList}
                                loading = { searchData_Loading }
                                onCellKeyDown              = {handleCellKeyDown}

                            />
                        </div>
                    </Frame>
                </div>
                <div className='dialog_traderList'>
                    <Dialog open={ openDialogTrader } onClose={ handleClick_dialog_trader_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="仲買人マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {traderList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', height:'70px'}}
                                    onClick = {() => handleClick_dataGrid_trader(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'25%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_trader_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishMethodList'>
                    <Dialog open={ openDialogFishMethod } onClose={ handleClick_dialog_fishMethod_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="漁法を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishMethodList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_fishMethod(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'25%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishMethod_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShip } onClose={ handleClick_dialog_ship_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {shipList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_ship(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'25%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_ship_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecList'>
                    <Dialog open={ openDialogFishSpec } onClose={ handleClick_dialog_fishSpec_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishSpecList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_fishSpec(item.originalCode, item.originalName)}
                                >{item.originalName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'25%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpec_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_tankList'>
                    <Dialog open={ openDialogTank } onClose={ handleClick_dialog_tank_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="水槽を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {tankList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_tank(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'25%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_tank_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarTrue_print}
                    onClose         = {() => setMessageInfo('snackBarTrue_print', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "印刷指示を送信しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_delete_row}
                    onClose   = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickNG = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickOK = {() => delete_row(0)}
                    message   = {'選択行を削除します。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_register}
                    onClose   = {() => setMessageInfo('confirm_register', false)}
                    onClickNG = {() => setMessageInfo('confirm_register', false)}
                    onClickOK = {() => register()}
                    message   = {'入力データを保存します。よろしいですか？'}
                />
        </>
    )
}
export default BidDataList;